<template>
  <div class="sidebar-wrap">
    <a-menu class="menu" mode="inline" :selectedKeys="[selectedMenu]">
      <a-menu-item key="/" :class="{ 'active': selectedMenu === '/account' }">
        <a-icon type="user" />
        <router-link to="/account" tag="span" class="menu-link">账户首页</router-link>
      </a-menu-item>
      <!--a-menu-item key="/account">
        <a-icon type="contacts" />
        <router-link to="/account" tag="span" class="menu-link">账户信息</router-link>
      </a-menu-item-->
      <!-- <a-menu-item key="/account/reportProject" v-if="isAgent">
        <a-icon type="project" />
        <router-link to="/account/reportProject" tag="span" class="menu-link">渠道项目报备</router-link>
      </a-menu-item> -->
      <!-- <a-menu-item key="/account/downloadhistory">
        <a-icon type="download" />
        <router-link to="/account/downloadhistory" tag="span" class="menu-link">下载历史</router-link>
      </a-menu-item> -->
      <a-menu-item key="/tech-support" :class="{ 'active': selectedMenu === '/account/tech-support' }">
        <a-icon type="customer-service" />
        <router-link to="/account/tech-support" tag="span" class="menu-link">技术支持</router-link>
      </a-menu-item>
      <!-- a-menu-item key="/license" :class="{ 'active': selectedMenu === '/account/license' }">
        <a-icon type="solution" />
        <router-link to="/account/license" tag="span" class="menu-link">软件授权</router-link>
      </a-menu-item -->
      <a-menu-item key="/billing" :class="{ 'active': selectedMenu === '/account/billing' }">
        <a-icon type="wallet" />
        <router-link to="/account/billing" tag="span" class="menu-link">财务管理</router-link>
      </a-menu-item>
    </a-menu>
  </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
  name: 'AccountSidebar',
  data () {
    return {}
  },
  computed: {
    ...mapState('app', {
      isAgent: state => state.customerCapability.is_agent,
    }),
    selectedMenu () {
      return this.$route.path
    },
  },
}
</script>
<style lang="less" scoped>
@import '~@/styles/less/theme';
.sidebar-wrap {
  position: fixed;
  top: 60px;
  left: 0;
  bottom: 0;
  z-index: 98;
}
.menu {
  width: 200px;
  height: 100vh;
  padding-top: 20px;
  font-weight: 500;
  font-size: 20px;
  padding-bottom: 60px;
}
.menu-link {
  display: inline-block;
  width: 80%;
}
.download {
  display: inline;
  color: rgba(0,0,0,.65);
}
.active {
  color: @primary-color;
}
</style>
